import { render, staticRenderFns } from "./PostLinksEditor.vue?vue&type=template&id=4613f8c3&scoped=true&"
import script from "./PostLinksEditor.vue?vue&type=script&lang=js&"
export * from "./PostLinksEditor.vue?vue&type=script&lang=js&"
import style0 from "./PostLinksEditor.vue?vue&type=style&index=0&id=4613f8c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613f8c3",
  null
  
)

export default component.exports